import React, { useState } from 'react'

// --- Data for the FAQs ---
const faqData = [
  {
    question: "How do I design my own T-shirt?",
    answer: "You can use our online design tool to upload your artwork, add text, and customize your T-shirt. If you need help, our design team is available to assist you."
  },
  {
    question: "What printing methods do you use?",
    answer: "We use advanced printing techniques including screen printing, direct-to-garment (DTG), and heat transfer, ensuring your designs are vibrant, detailed, and long-lasting.",
    defaultOpen: true 
  },
  {
    question: "Can I place bulk or corporate orders?",
    answer: "Absolutely! We offer discounts for bulk and corporate orders. Please contact our sales team for a custom quote."
  },
  {
    question: "How long will it take to receive my order?",
    answer: "Standard shipping typically takes 5-7 business days. Expedited shipping options are available at checkout."
  },
  {
    question: "What if I'm not satisfied with my order?",
    answer: "Your satisfaction is our priority. If you're not happy with your order, please contact our customer support within 30 days for a return or replacement."
  },
  {
    question: "Do you ship outside California?",
    answer: "Yes! While we're proudly based in California, we offer nationwide shipping across the U.S. and international delivery options for select countries.",
    defaultOpen: true
  },
  {
    question: "Can I use my own logo or artwork?",
    answer: "Yes, you can upload your own logo, artwork, or photos. Please ensure they meet our file format and resolution guidelines for the best print quality."
  },
  {
    question: "What file formats do you accept for designs?",
    answer: "We accept a variety of file formats, including PNG, JPEG, PDF, AI, and PSD. For best results, we recommend high-resolution PNG or vector files."
  },
  {
    question: "Do you offer design assistance?",
    answer: "We do! If you have an idea but need help bringing it to life, our team of professional designers can assist you with your artwork."
  },
  {
    question: "Can I print on both sides of the T-shirt?",
    answer: "Yes, you can choose to print on the front, back, or both sides of the T-shirt during the design process."
  }
];


// --- Individual FAQ Item Component ---
function FaqItem({ question, answer, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-gray-200 rounded-lg shadow-sm">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex justify-between items-center w-full p-5 text-left"
        aria-expanded={isOpen}
      >
        {/* Updated text color to gray-900 for a stronger look */}
        <span className="font-semibold text-gray-900">{question}</span>
        <span className="text-2xl font-light text-gray-500">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {/* Updated text color to gray-500 to match your paragraph style */}
        <div className="p-5 pt-0 text-gray-500">
          {answer}
        </div>
      </div>
    </div>
  );
}


// --- Main FAQs Component ---
function Faqs() {
  const middleIndex = Math.ceil(faqData.length / 2);
  const firstColumn = faqData.slice(0, middleIndex);
  const secondColumn = faqData.slice(middleIndex);

  return (
    // Added font-custom here to apply to the whole section
    <div className="bg-white py-16 sm:py-24 font-custom">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          {/* This text-gray-500 already matches your service component */}
          <p className="text-sm font-medium text-gray-500 uppercase tracking-wider">FAQs</p>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {/* Updated highlight to teal-100 to match your theme */}
            <span className="bg-teal-100 px-2 py-1">Frequently Ask Questions</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
          
          {/* First Column */}
          <div className="flex flex-col gap-4">
            {firstColumn.map((faq, index) => (
              <FaqItem 
                key={index} 
                question={faq.question} 
                answer={faq.answer}
                defaultOpen={faq.defaultOpen}
              />
            ))}
          </div>
          
          {/* Second Column */}
          <div className="flex flex-col gap-4">
            {secondColumn.map((faq, index) => (
              <FaqItem 
                key={index + middleIndex} 
                question={faq.question} 
                answer={faq.answer}
                defaultOpen={faq.defaultOpen}
              />
            ))}
          </div>
        </div>
        
      </div>
    </div>
  )
}

export default Faqs